export { useWorkspaceSession as usePermissionQueryScope } from '../useWorkspaceSession'
